import { useEffect, useCallback, useState } from 'react';
// routes
import { Box, Card, Stack, Typography } from '@mui/material';
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
//
import Logo from 'src/components/logo';
import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

const loginPaths: Record<string, string> = {
  jwt: paths.auth.login,
};

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

const InactivePage = function () {
  return <Box p={4} display="flex" justifyContent="center">
    <Card sx={{ p: 4, maxWidth: "800px" }}>
      <Stack gap={2}>
        <Logo large sx={{ marginBottom: 4, marginTop: 2 }} />
        <Typography variant="h3" component="h1" textAlign="center">Your account was successfully created!</Typography>
        <Typography component="p" textAlign="center">Please be patient, we are working on getting your account approved!</Typography>
        <Typography component="p" textAlign="center">Have questions? Reach out <a href="mailto:support@countingtrucks.com">support@countingtrucks.com</a></Typography>
      </Stack>
    </Card>
  </Box>;
}

export default function AuthGuard({ children }: Props) {
  const router = useRouter();

  const { authenticated, session, method } = useAuthContext();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!authenticated) {
      const searchParams = new URLSearchParams({
        returnTo: window.location.pathname,
      }).toString();

      const loginPath = loginPaths[method];

      const href = `${loginPath}?${searchParams}`;

      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [authenticated, method, router]);

  useEffect(() => {
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!checked) {
    return null;
  }

  const active = !!(session?.organization?.active);

  return <>
    {active ? children : <InactivePage />}
  </>;
}
